module.exports = "<app-society [temp]=\"temp\"></app-society>"